import { render, staticRenderFns } from "./TextBlockUiComponent.vue?vue&type=template&id=e96748c4&"
import script from "./TextBlockUiComponent.vue?vue&type=script&lang=ts&"
export * from "./TextBlockUiComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports